import {
    cleanCommonParams,
    mapImageParams,
} from './common';

const mapCollateralLogoParams = (
    isCreate,
    {
        image,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            collateral_logo: {
                ...cleanCommonParams(params),
                ...mapImageParams(isCreate, image),
            },
        });
    });
};

export { mapCollateralLogoParams };
